import { Typography } from '@mui/material'
import { styled } from '@mui/styles'

export const Title = styled(Typography)({
  display: 'flex',
  gap: 8,
  lineHeight: '1.4 !important',
  fontWeight: '700 !important',
  fontSize: '1.2rem !important',
  alignItems: 'center !important',
})

export const Subtitle = styled('span')({
  fontWeight: 400,
  fontSize: 16,
})
